import { Component, onMount } from 'solid-js'
import PageHeader from '/web/shared/PageHeader'
import { Pill, SolidCard } from '/web/shared/Card'
import Button from '/web/shared/Button'
import { useSearchParams } from '@solidjs/router'
import { userStore, i18nStore } from '/web/store'
import { Page } from '/web/Layout'

export const CheckoutSuccess: Component = (props) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const [query] = useSearchParams()

  onMount(() => {
    userStore.finishCheckout(query.session_id!, 'success', () => {
      window.close()
    })
  })

  return (
    <Page>
      <PageHeader title={i18n.t.profile_checkout_success} />
      <div class="flex flex-col items-center gap-4">
        <SolidCard class="flex flex-col items-center gap-4">
          <p class="font-bold">{i18n.t.profile_checkout_thank_you}</p>

          <p
            innerHTML={i18n.t.profile_checkout_start_using.replace(
              '{name}',
              `<span class="pill pill-hl">Agnaistic</span>`
            )}
          />
        </SolidCard>
        <Button onClick={() => window.close()}>{i18n.t.profile_checkout_close_window}</Button>
      </div>
    </Page>
  )
}

export const CheckoutCancel: Component = (props) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const [query] = useSearchParams()

  onMount(() => {
    userStore.finishCheckout(query.session_id!, 'cancel')
  })

  return (
    <Page>
      <PageHeader title={i18n.t.profile_checkout_cancelled} />

      <div class="flex flex-col items-center gap-4">
        <SolidCard class="flex flex-col items-center gap-4" bg="orange-600">
          <p>{i18n.t.profile_checkout_cancelled_msg}</p>
        </SolidCard>
        <Button onClick={() => window.close()}>{i18n.t.profile_checkout_close_window}</Button>
      </div>
    </Page>
  )
}
